<script>
export default {
  name: 'chatBox',
  props: {
    title: {
      type: String,
      default: '',
    },
    page: {
      type: String,
      default: '',
    }
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
}
</script>

<template>
  <div class="custom-chatbox">
    <x-icon-chatbox :page="page" class="chatbox"/>
    <div class="chatbox-title"><slot></slot></div>
  </div>
</template>

<style lang="scss" scoped>
@import 'chatbox.scss';
</style>
